"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  buildTime: "2022-09-01T20:30:09Z",
  commit: "d42788cf287fb2bc47984405dbd6de9dec4469c3",
  npmInfo: {
    'solid-panes': '3.5.26',
    npm: '8.18.0',
    node: '14.17.3',
    v8: '8.4.371.23-node.67',
    uv: '1.41.0',
    zlib: '1.2.11',
    brotli: '1.0.9',
    ares: '1.17.1',
    modules: '83',
    nghttp2: '1.42.0',
    napi: '8',
    llhttp: '2.1.3',
    openssl: '1.1.1k',
    cldr: '39.0',
    icu: '69.1',
    tz: '2021a',
    unicode: '13.0'
  }
};
exports["default"] = _default;
//# sourceMappingURL=versionInfo.js.map